export const PRODUCTS_API = (process.env.REACT_APP_PRODUCTS_API || '/api').replace(/\/$/, '');
export const PAYMENTS_API = (process.env.REACT_APP_PAYMENTS_API || '/api').replace(/\/$/, '');
export async function request(url, options = {}) {
  const response = await fetch(url, options);
  if (!response.ok) {
    let detail = '';
    try { const payload = await response.json(); detail = typeof payload.message === 'string' ? payload.message : ''; } catch {}
    const error = new Error(detail || (response.status === 401 || response.status === 403 ? 'No tenés permiso para realizar esta acción.' : `La solicitud falló (${response.status}).`));
    error.status = response.status; throw error;
  }
  if (response.status === 204) return null;
  const body = await response.text();
  if (!body) return null;
  return response.headers.get('content-type')?.includes('application/json') ? JSON.parse(body) : body;
}
